/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import { SetStateAction, useEffect } from 'react';
import { Formik } from 'formik';

import SecundButton from 'components/form/buttons/secundButton';
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';
// import { useActions } from "common/hooks/useActions";

import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { useActions } from 'common/hooks/useActions';
import DropDown from 'components/form/dropDown';
import { EventTypeEnumArray } from 'common/enums';
import DateInput from 'components/form/dateInput';
import OutlineButton from 'components/form/buttons/outLineButton';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  setFilter: SetStateAction<any>;
  departments: string[];
  filter: any;
  contributor?: boolean;
}

export default function EventFilterPopup({ setFilter, filter, departments, contributor }: IProps) {
  const { departmentsRequestAction } = useActions();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    departmentsRequestAction();
  };

  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 245, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            style={{ background: '#8A93AC' }}
            colorIcon="var(--white)"
          >
            Filters
          </SecundButton>
        }
      >
        <PanelBoxLayout
          style={{ padding: 15 }}
          titleStyle={{ color: '#2D3748', fontSize: 14 }}
          title="Filters"
          icon="/icons/stroke/filter.svg"
        >
          <Formik
            initialValues={{
              type: '',
              department: '',
              date: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values, page: 1 });
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              resetForm,
              setValues
            }) => (
              <>
                {!contributor && (
                  <>
                    <DropDown
                      label="Type"
                      list={EventTypeEnumArray}
                      onChange={(e: T.Form.ListDropdownItem) => {
                        setValues({
                          ...values,
                          type: e.id as any
                        });
                      }}
                      defaultValue={{
                        title: values.type,
                        id: values.type
                      }}
                      placeholder="Select Type"
                      message={touched.type && (errors.type as any)}
                      error={errors.type as unknown as boolean}
                      inputStyle={{
                        height: 40,
                        borderRadius: 7,
                        fontSize: 12,
                        padding: '0 15px'
                      }}
                      labelStyle={{ fontSize: 12 }}
                    />

                    <Gap size="10px" />
                  </>
                )}

                <DropDown
                  label="Department"
                  list={departments.map((item: any) => {
                    return { title: item, id: item };
                  })}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      department: e.id as any
                    });
                  }}
                  defaultValue={{
                    title: values.department,
                    id: values.department
                  }}
                  placeholder="Select Type"
                  message={touched.type && (errors.type as any)}
                  error={errors.type as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="10px" />
                {!contributor && (
                  <>
                    <DateInput
                      onChange={(e) => {
                        setValues({
                          ...values,
                          date: e
                        });
                      }}
                      placeholder="Event Start Date"
                      label="Event Start Date"
                      defaultDate={values.date}
                      message={touched.date && (errors.date as any)}
                      error={touched.date && (errors.date as unknown as boolean)}
                      inputStyle={{
                        height: 40,
                        borderRadius: 7,
                        fontSize: 12,
                        padding: '0 15px'
                      }}
                      labelStyle={{ fontSize: 12 }}
                    />
                    <Gap size="20px" />
                  </>
                )}

                <PrimaryButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                >
                  Filter
                </PrimaryButton>
                <Gap size="10px" />

                <OutlineButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={() => {
                    resetForm();
                    handleSubmit();
                  }}
                  // disabled={isSubmitting}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
